import React from 'react';
import s from '../AnnualReviewReport.module.scss';

const SectionHeader = ({ title, sourceLabel }) => (
  <div className={s.sectionHeader}>
    <div className={s.sectionHeaderContent}>
      <h3 className={s.sectionTitle}>{title}</h3>
      {sourceLabel && (
        <span
          className={s.sourceLabelInline}
          aria-label={`Source: ${sourceLabel}`}
        >
          {sourceLabel}
        </span>
      )}
    </div>
  </div>
);

export default SectionHeader;
